
import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';

// // Components
import GetInTouch from "../components/gettouch";
import PortfolioCards from "../components/card-portfolio"
// import ServicesCards from "../components/card-services";

import image01 from "../assets/image/services/1st-scalability-hygiene.png"
import image02 from "../assets/image/Home/Services/Consulting-Services-2.png"
import image03 from "../assets/image/Home/Services/Engineered-Solutions-1.png"
import image04 from "../assets/image/Home/Services/Engineered-Solutions-2.png"

import banner from "../assets/image/services/Services-large-image.png"

const images = [
image01,
image02,
image03,
image04
];

export default function Services() {


      const comp = useRef();
  const tl = useRef();

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      tl.current = gsap.timeline({ defaults: { ease: "power3.out" } });

      // intro paragraph
      tl.current.from(".hero-text", {
        opacity: 0,
        y: 40,
        duration: 1,
      });

      // main words
      tl.current.from(".h1-ss.is-1", {
        x: "3em",
        opacity: 0,
        duration: 1.2,
      }, "-=0.6");

      tl.current.from(".h1-ss.is-2", {
        y: 80,
        opacity: 0,
        duration: 1.2,
      }, "-=0.9");

      tl.current.from(".h1-ss.is-3", {
        x: "-3em",
        opacity: 0,
        duration: 1.2,
      }, "-=0.9");

      // small words
      tl.current.from(".is-s-hero-ab", {
        y: 30,
        opacity: 0,
        stagger: 0.15,
        duration: 0.8,
      }, "-=0.8");



// IMAGE CAROUSEL LOOP (SEAMLESS)
// const slides = gsap.utils.toArray(".faq-img");

// gsap.set(slides, { xPercent: 100 });
// gsap.set(slides[0], { xPercent: 0 });

// function createCarouselLoop() {
//   const loop = gsap.timeline({
//     repeat: -1,
//     defaults: { ease: "power2.inOut" }
//   });

//   slides.forEach((slide, i) => {
//     const nextIndex = (i + 1) % slides.length;

//     loop
    
//       .to(".whipe-img", {
//         width: "100%",
//         duration: 0.7
//       })

    
//       .to(slides[i], {
//         xPercent: -100,
//         duration: 0.8
//       }, "<")


//       .set(slides[nextIndex], { xPercent: 100 }, "<")

//       .to(slides[nextIndex], {
//         xPercent: 0,
//         duration: 0.8
//       }, "<")

      
//       .to(".whipe-img", {
//         width: "0%",
//         duration: 0.7
//       });
//   });

//   return loop;
// }

// start carousel AFTER hero animation finishes
// tl.current.add(createCarouselLoop(), "+=0.2");
    }, comp);

    return () => ctx.revert();
  }, []);
   return (
       <div className="main-wrapper">
      <section className="hero-100 is-serv-hero" ref={comp}>
    <div className="container-lg is-serv-hero">
        <div className="flex-cc">
            <div className="is-s-hero-ab d-20">
                <p className="text"> Everything your facility needs to produce safe food, protect your brand, and increase throughput.</p>
            </div>
            <div className="h1-s-wrap is-s-wrap-1">
                <h1 className="h1-ss is-1">One integrated</h1>
            </div>
        </div>
        <div className="flex-split-top">
            <div className="h1-s-wrap">
                <h1 className="h1-ss is-2">framework.</h1>
            </div>
            <div className="slider-img-wrapper">
  <Swiper
  loop={true}
  autoplay={{
    delay: 2000,
    disableOnInteraction: false,
  }}
  allowTouchMove={true}
  modules={[Autoplay]}
  spaceBetween={24}
  slidesPerView={3}
  breakpoints={{
    0: {
      slidesPerView: 1,
      spaceBetween: 3,
    },
    760: {
      slidesPerView: 1,
      spaceBetween: 3,
    },
    1024: {
      slidesPerView: 1,
      spaceBetween: 3,
    },
  }}
>
  {images.map((img, i) => (
    <SwiperSlide key={i}>
      
        <div className="img-child">
          <div
            className="faq-img"
            style={{ backgroundImage: `url(${img})` }}
          />
        </div>
    </SwiperSlide>
  ))}
</Swiper>
            </div>
        
           
            <div className="h1-sm-wrap">
                <h1 className="h1-sm">Four</h1>
            </div>
        </div>
        <div className="flex-cc">
            <div className="h1-s-wrap is-s-wrap-2">
                <h1 className="h1-sm">pillars.</h1>
            </div>
        </div>
        {/* <div className="flex-l-s">
            <div className="h1-sm-wrap is-s-wrap-3">
                <h1 className="h1-sm">OUR FOODSAFE PORTFOLIO</h1>
            </div>
        </div> */}
    </div>
    <div className="container-lg is-serv-hero is-mobile">
        <div className="flex-cc is-mobile-left">
            <div className="h1-s-wrap">
                <div className="is-s-hero-ab d-55">
                    <p className="text"> Everything your facility needs to produce safe food, protect your brand, and increase throughput.</p>
                </div>
                <h1 className="h1-ss is-1">One integrated</h1>
            </div>
        </div>
        <div className="flex-split-top is-mobile-left">
            <div className="h1-s-wrap is-2">
                <h1 className="h1-ss is-2">framework.</h1>
            </div>
        </div>
        {/* <div className="flex-l-s">
            <div className="h1-sm-wrap">
                <h1 className="h1-sm">And</h1>
            </div>
        </div> */}
        <div className="flex-split-top is-mobile-h">
              <div className="slider-img-wrapper">
  <Swiper
  loop={true}
  autoplay={{
    delay: 2000,
    disableOnInteraction: false,
  }}
  allowTouchMove={true}
  modules={[Autoplay]}
  spaceBetween={24}
  slidesPerView={3}
  breakpoints={{
    0: {
      slidesPerView: 1,
      spaceBetween: 3,
    },
    760: {
      slidesPerView: 1,
      spaceBetween: 3,
    },
    1024: {
      slidesPerView: 1,
      spaceBetween: 3,
    },
  }}
>
  {images.map((img, i) => (
    <SwiperSlide key={i}>
      
        <div className="img-child">
          <div
            className="faq-img"
            style={{ backgroundImage: `url(${img})` }}
          />
        </div>
    </SwiperSlide>
  ))}
</Swiper>
            </div>
        
           
        </div>
        <div className="flex-r-s">
            <div className="h1-s-wrap is-right">
                <h1 className="h1-ss is-3"> framework.</h1>
            </div>
        </div>
        <div className="flex-l-s is-mobile-right is-1">
            <div className="h1-sm-wrap">
                <h1 className="h1-sm">Four pillars.</h1>
            </div>
        </div>
        {/* <div className="flex-l-s is-mobile-right is-2">
            <div className="h1-sm-wrap">
                <h1 className="h1-sm">Assets</h1>
            </div>
        </div> */}
    </div>
</section>
    <PortfolioCards/>

    
    <div className="above-footer-section">
        <div className="section is-no-pad">
    <div className="banner-img is-service">
        <div className="img-child">
            <div className="banner-img-frame">
                <img src={banner} alt={banner}/>
            </div>
        </div>
    
    </div>
</div>
    </div>
    <GetInTouch/>
       </div>
    )
}